<!--查看更多类组件 5-->
<template>
    <div class="view11Wrapper shadowRadius cardPadding cardWidth">
        <div class="tipsGlobalText tips" :style="`marginBottom:${tips.length<80?'.6rem':''}`" v-html="newTips">
<!--            {{tips}}-->
        </div>

        <div class="more">

        <RButton color="viewMore" @on-click="()=>onSwitch(true,tips)" v-if="tips.length>80" >
           查看更多
        </RButton>
        </div>
        <div class="v11Items" v-if="list.length">
            <div class="tipsGlobalText">为您推荐：</div>
            <div v-for="(item,ix) in list" :key="`vi-11-${ix}`"
                 @click="()=>onAsk(item.name,item.value)" class="nameBox">
                <span class="name">{{item.name}}</span>
            </div>
        </div>
    </div>
</template>
<script>
    import RButton from '../Use/r-button'
    import {mapMutations} from "vuex";
    export default {
        name: "View11",
        components: {RButton},
        props: {
            list: {
                type: Array,
                default: ()=>[]
            },
            tips: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                isClose:false,
                propsTips: ''
            };

        },
        computed: {
            newTips(){
                let newTips = this.onSilce(this.tips)
                this.propsTips = newTips
                return newTips
            }
        },
        // created() {
        //     this.onSilce(this.tips)
        // },
        methods: {
            ...mapMutations([
           "setToastContent","setToastShow"
            ]),
            onAsk(name, value) {
                this.$emit("on-ask", name, value);
            },
            onSwitch(value,tips){
                this.setToastShow(true)
                this.setToastContent({toastType: 0,list:{name:'',content:this.propsTips}})
            },
            onSilce(tips){
                let posIndex=[],
                    len=tips.length,
                    pos=0;
                while(pos<len){
                    pos=tips.indexOf('data-w-e="1"',pos);
                    if(pos===-1){//未找到就退出循环完成搜索
                        break;
                    }
                    posIndex.push(pos);//找到就存储索引
                    pos+=1;//并从下个位置开始搜索
                }
                posIndex.map((item, index) => {
                    if(index === 0){
                        tips = tips.slice(0, item+12) + ' class="emoji"' + tips.slice(item+12)
                    }
                    else{
                        tips = tips.slice(0, item+12+14*index) + ' class="emoji"' + tips.slice(item+12+14*index)
                    }

                })
                // console.log(tips)
                return tips;
            }
        }
    };
</script>
<style lang="less" scoped>
    @import "../../assets/less/common";
    .view11Wrapper {
        /*min-width: 6rem;*/
        /*width: 100%;*/
        width: 8.25rem;

        .tips {
            height: 6em;
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
        }

        .more {


            text-align: center;
        }





        .v11Items {
            background: rgba(255, 255, 255, 1);
            padding: .36rem .3rem;

            .nameBox {

            }

            .name {
                color: @primary-color;
                display: block;
                padding: .2rem 0;
                font-size: .36rem;
            }

        }

    }

</style>
